(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["geske-main-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('section') || document.querySelector('[data-section-type="main-collection"]');
    if (!section) return;

    // Filter drawer
    const drawer = section.querySelector('[data-filter-drawer]');
    const openBtn = section.querySelector('[data-filter-open]');
    const closeEls = section.querySelectorAll('[data-filter-close]');

    const openDrawer = () => {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openBtn?.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openBtn?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };

    openBtn?.addEventListener('click', openDrawer);
    closeEls.forEach(el => el.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

    // Sort -> navigate on change
    const sortSelect = section.querySelector('[data-sort-select]');
    sortSelect?.addEventListener('change', (e) => {
      const val = e.target.value;
      if (!val) return;
      const current = new URL(window.location.href);
      current.searchParams.set('sort_by', val);
      current.searchParams.delete('page');
      window.location.href = current.toString();
    });

    // Grid density toggle
    const grid = section.querySelector('[data-product-grid]');
    const gridButtons = section.querySelectorAll('[data-grid-cols]');
    const storedCols = localStorage.getItem('geske:gridCols');
    if (storedCols && grid && (storedCols === '3' || storedCols === '4')) {
      grid.dataset.columns = storedCols;
      grid.style.setProperty('--grid-columns', storedCols);
      gridButtons.forEach(b => b.classList.toggle('is-active', b.dataset.gridCols === storedCols));
    }
    gridButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const cols = btn.dataset.gridCols;
        if (!grid || !cols) return;
        grid.dataset.columns = cols;
        grid.style.setProperty('--grid-columns', cols);
        gridButtons.forEach(b => b.classList.toggle('is-active', b === btn));
        localStorage.setItem('geske:gridCols', cols);
      });
    });

    // Load more (AJAX append)
    const loadMoreBtn = section.querySelector('[data-load-more]');
    loadMoreBtn?.addEventListener('click', async (e) => {
      e.preventDefault();
      const nextUrl = loadMoreBtn.getAttribute('href');
      if (!nextUrl) return;
      loadMoreBtn.classList.add('is-loading');
      loadMoreBtn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(nextUrl, { headers: { 'Accept': 'text/html' } });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-product-grid]');
        const newBtn = doc.querySelector('[data-load-more]');
        if (newGrid && grid) {
          grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
        }
        if (newBtn) {
          loadMoreBtn.setAttribute('href', newBtn.getAttribute('href'));
        } else {
          loadMoreBtn.closest('.collection-load-more')?.remove();
          section.querySelector('.collection-pagination-info')?.remove();
        }
      } catch (err) {
        console.error('Load more failed', err);
        window.location.href = nextUrl;
      } finally {
        loadMoreBtn.classList.remove('is-loading');
        loadMoreBtn.removeAttribute('aria-busy');
      }
    });

    // Page size links
    section.querySelectorAll('[data-per-page]').forEach(link => {
      link.addEventListener('click', (e) => {
        const url = new URL(link.href, window.location.origin);
        const current = new URL(window.location.href);
        current.searchParams.set('per_page', link.dataset.perPage);
        current.searchParams.delete('page');
        e.preventDefault();
        window.location.href = current.toString();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-coming-soon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Scroll progress */
      var bar = document.querySelector('[data-lp-progress]');
      if (bar) {
        var onScroll = function () {
          var doc = document.documentElement;
          var max = doc.scrollHeight - doc.clientHeight;
          var p = max > 0 ? doc.scrollTop / max : 0;
          bar.style.transform = 'scaleX(' + p + ')';
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        onScroll();
      }

      /* Hero video — force muted autoplay (matches landing page) */
      var video = document.querySelector('[data-lp-video]');
      if (video) {
        video.muted = true;
        var tryPlay = function () {
          var pr = video.play();
          if (pr && pr.catch) pr.catch(function () {});
        };
        tryPlay();
        video.addEventListener('loadedmetadata', tryPlay);
        video.addEventListener('canplay', tryPlay);
      }

      /* WebGL pulse field */
      initPulse(reduce);

      /* Newsletter → Klaviyo client subscriptions */
      initNewsletter();
    }

    function initPulse(reduce) {
      var canvas = document.querySelector('[data-lp-pulse]');
      if (!canvas || reduce) return;
      var gl = canvas.getContext('webgl2', { premultipliedAlpha: false, alpha: true, antialias: false });
      if (!gl) return;

      var VERT = '#version 300 es\n' +
        'in vec2 a_position;\n' +
        'void main() { gl_Position = vec4(a_position, 0.0, 1.0); }';

      var FRAG = '#version 300 es\n' +
        'precision highp float;\n' +
        'uniform vec2 u_resolution;\n' +
        'uniform vec2 u_mouse;\n' +
        'uniform float u_time;\n' +
        'uniform float u_intensity;\n' +
        'out vec4 outColor;\n' +
        'vec2 drift(float t, float seed) {\n' +
        '  float a = t * 0.07 + seed * 6.2831;\n' +
        '  return vec2(0.5 + 0.35 * cos(a), 0.45 + 0.25 * sin(a * 1.3 + seed));\n' +
        '}\n' +
        'float wave(vec2 uv, vec2 c, float t, float speed, float scale) {\n' +
        '  float d = distance(uv, c);\n' +
        '  return 0.5 + 0.5 * sin(d * scale - t * speed);\n' +
        '}\n' +
        'void main() {\n' +
        '  vec2 uv = gl_FragCoord.xy / u_resolution;\n' +
        '  uv.x *= u_resolution.x / u_resolution.y;\n' +
        '  vec2 m = u_mouse;\n' +
        '  m.x *= u_resolution.x / u_resolution.y;\n' +
        '  float t = u_time;\n' +
        '  vec2 c0 = drift(t, 0.0);\n' +
        '  vec2 c1 = drift(t, 0.37);\n' +
        '  vec2 c2 = drift(t, 0.71);\n' +
        '  c0.x *= u_resolution.x / u_resolution.y;\n' +
        '  c1.x *= u_resolution.x / u_resolution.y;\n' +
        '  c2.x *= u_resolution.x / u_resolution.y;\n' +
        '  float w = wave(uv, c0, t, 1.1, 18.0) * 0.33 + wave(uv, c1, t, 0.7, 12.0) * 0.33 + wave(uv, c2, t, 1.4, 24.0) * 0.34;\n' +
        '  float mouseWave = wave(uv, m, t, 2.6, 30.0);\n' +
        '  float mouseDist = distance(uv, m);\n' +
        '  float mouseFalloff = exp(-mouseDist * 2.8);\n' +
        '  w = mix(w, w * 0.6 + mouseWave * 0.7, mouseFalloff * u_intensity);\n' +
        '  vec2 centred = uv - vec2(u_resolution.x / u_resolution.y * 0.5, 0.5);\n' +
        '  float vignette = 1.0 - smoothstep(0.4, 1.05, length(centred));\n' +
        '  float alpha = (w * 0.18 + mouseWave * 0.12 * mouseFalloff * u_intensity) * vignette;\n' +
        '  outColor = vec4(vec3(0.95, 0.97, 1.0), clamp(alpha, 0.0, 0.32));\n' +
        '}';

      function compile(type, src) {
        var sh = gl.createShader(type);
        gl.shaderSource(sh, src);
        gl.compileShader(sh);
        if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) {
          gl.deleteShader(sh);
          return null;
        }
        return sh;
      }

      var vs = compile(gl.VERTEX_SHADER, VERT);
      var fs = compile(gl.FRAGMENT_SHADER, FRAG);
      if (!vs || !fs) return;
      var program = gl.createProgram();
      gl.attachShader(program, vs);
      gl.attachShader(program, fs);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return;
      gl.useProgram(program);

      var buf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), gl.STATIC_DRAW);
      var aPos = gl.getAttribLocation(program, 'a_position');
      gl.enableVertexAttribArray(aPos);
      gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);

      var uRes = gl.getUniformLocation(program, 'u_resolution');
      var uMouse = gl.getUniformLocation(program, 'u_mouse');
      var uTime = gl.getUniformLocation(program, 'u_time');
      var uIntensity = gl.getUniformLocation(program, 'u_intensity');

      gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

      var state = { mouse: [0.5, 0.5], targetIntensity: 0.4, intensity: 0.4, start: performance.now(), raf: 0, visible: true };

      function resize() {
        var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
        var w = canvas.clientWidth;
        var h = canvas.clientHeight;
        var dw = Math.max(1, Math.round(w * dpr));
        var dh = Math.max(1, Math.round(h * dpr));
        if (canvas.width !== dw || canvas.height !== dh) {
          canvas.width = dw;
          canvas.height = dh;
          gl.viewport(0, 0, dw, dh);
        }
      }

      function onMove(e) {
        var rect = canvas.getBoundingClientRect();
        state.mouse[0] = (e.clientX - rect.left) / rect.width;
        state.mouse[1] = 1 - (e.clientY - rect.top) / rect.height;
        state.targetIntensity = 1.0;
      }

      function onLeave() { state.targetIntensity = 0.4; }

      function loop() {
        if (!state.visible) { state.raf = requestAnimationFrame(loop); return; }
        resize();
        var t = (performance.now() - state.start) / 1000;
        state.intensity += (state.targetIntensity - state.intensity) * 0.04;
        gl.uniform2f(uRes, canvas.width, canvas.height);
        gl.uniform2f(uMouse, state.mouse[0], state.mouse[1]);
        gl.uniform1f(uTime, t);
        gl.uniform1f(uIntensity, state.intensity);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
        state.raf = requestAnimationFrame(loop);
      }

      var io = new IntersectionObserver(function (entries) {
        state.visible = entries[0] ? entries[0].isIntersecting : false;
      }, { threshold: 0 });
      io.observe(canvas);

      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerleave', onLeave);
      window.addEventListener('resize', resize);
      resize();
      state.raf = requestAnimationFrame(loop);
    }

    function initNewsletter() {
      var form = document.querySelector('[data-lp-newsletter]');
      if (!form) return;
      var input = form.querySelector('input[name="email"]');
      var submit = form.querySelector('[data-lp-submit]');
      var message = form.querySelector('[data-lp-message]');
      var success = document.querySelector('[data-lp-success]');
      var company = form.getAttribute('data-company');
      var list = form.getAttribute('data-list');
      var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      var ERROR_COPY = {
        empty: 'Please enter your email address.',
        invalid_email: 'That email address does not look right.',
        server_error: 'We could not save your details. Please try again in a minute.'
      };

      function showError(code) {
        message.textContent = ERROR_COPY[code] || ERROR_COPY.server_error;
        message.classList.add('geske-lp__newsletter-fine--error');
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (input.value || '').trim();
        if (!email) { showError('empty'); return; }
        if (!EMAIL_RE.test(email) || email.length > 254) { showError('invalid_email'); return; }

        submit.disabled = true;
        submit.textContent = 'Sending';

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'GESKE UK Password Page',
                profile: { data: { type: 'profile', attributes: { email: email } } }
              },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          })
        }).then(function (res) {
          if (res.ok || res.status === 202) {
            form.hidden = true;
            if (success) success.hidden = false;
          } else {
            submit.disabled = false;
            submit.textContent = 'Get the newsletter';
            showError('server_error');
          }
        }).catch(function () {
          submit.disabled = false;
          submit.textContent = 'Get the newsletter';
          showError('server_error');
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordions"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function tagSubheads() {
      document
        .querySelectorAll('.product-accordion__body .rte p')
        .forEach(function (p) {
          if (p.children.length !== 1) return;
          var only = p.children[0];
          if (only.tagName !== 'STRONG') return;
          // Whole-paragraph match: excludes "<strong>Lead in.</strong> body copy".
          if (p.textContent.trim() !== only.textContent.trim()) return;
          p.classList.add('rte-subhead');
        });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tagSubheads);
    } else {
      tagSubheads();
    }
    // Section re-render inside the theme editor.
    document.addEventListener('shopify:section:load', tagSubheads);
  })();

  } catch(e) { console.error(e); }
})();
})();
